import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListItem } from '../models/lists.model';
import { GenericListService } from './lists.service';

export enum ARColzaListType {
  COLZA_ORGANIC_PRODUCT_TYPES,
  COLZA_AZOTE_PRODUCT_TYPES,
  COLZA_AZOTE_FREQUENCIES,
  COLZA_RESULT_TYPES,
  COLZA_ORDER_TYPES,
}

// TODO refactor lists.service pour ne pas dupliquer le code ?
@Injectable({ providedIn: 'root' })
export class ARColzaListsService extends GenericListService<ARColzaListType> {
  constructor(http: HttpClient) {
    super(http);
    this.listsUrl = '/tools/agrorendement/colza/lists';
  }

  handleResponse(response: any) {
    const data = response.data;
    const converted = new Map<ARColzaListType, ListItem[]>();
    for (const d in data) {
      const listType: ARColzaListType = <any>ARColzaListType[<any>d];
      const value = data[d];
      const typeData = value.map(this.extractI18n);
      converted.set(listType, typeData);
      this.cache.set(listType, typeData);
    }
    return converted;
  }
}
